import GiftModal from './GiftModal';

export default GiftModal;
